module.exports = __webpack_public_path__ + "img/slide_7.3ca8e92a.jpg";